import axios from 'axios';

function getInstanceFederation() {
  return axios.get('/federation.json');
}

export { 
    getInstanceFederation
};